export const NEW_TEMPLATE_SECTION = {
    // Sidebar
    SEARCH: { key: 'SEARCH', value: 'Search' },
    STUDIO: { key: 'STUDIO', value: 'Studio' },
    SEARCH_BY_NAME_PLACEHOLDER: {
        key: 'SEARCH_BY_NAME_PLACEHOLDER',
        value: 'Search by name...',
    },
    CATEGORIES: { key: 'CATEGORIES', value: 'Categories' },
    FOLDERS: { key: 'FOLDERS', value: 'Folders' },
    TEAMS: { key: 'TEAMS', value: 'Teams' },
    LANGUAGES: { key: 'LANGUAGES', value: 'Languages' },
    QUICK_ACCESS: { key: 'QUICK_ACCESS', value: 'Quick Access' },
    ALL: { key: 'ALL', value: 'All' },
    STATUS: { key: 'STATUS', value: 'Status' },
    WAITING_FOR_APPROVAL: {
        key: 'WAITING_FOR_APPROVAL',
        value: 'Waiting for Approval',
    },
    NEEDS_CHANGES: { key: 'NEEDS_CHANGES', value: 'Needs Changes' },
    SEARCH_BY_TAGS: { key: 'SEARCH_BY_TAGS', value: 'Search by Tags' },
    ALL_CATEGORIES: { key: 'ALL_CATEGORIES', value: 'All Categories' },
    ALL_FOLDERS: { key: 'ALL_FOLDERS', value: 'All Folders' },
    ALL_TEAMS: { key: 'ALL_TEAMS', value: 'All Teams' },
    ALL_LANGUAGES: { key: 'ALL_LANGUAGES', value: 'All Languages' },
    FAILED_TO_LOAD_TEMPLATE_COUNT: {
        key: 'FAILED_TO_LOAD_TEMPLATE_COUNT',
        value: 'Failed to load template count and filters.',
    },
    NO_DATA_AVAILABLE: { key: 'NO_DATA_AVAILABLE', value: 'No data available' },

    // TopBar
    DOCUMENTS: { key: 'DOCUMENTS', value: 'Documents' },
    DOCUMENTS_DESC: {
        key: 'DOCUMENTS_DESC',
        value: 'Design, edit, and manage your documents',
    },
    REUSABLE_PAGES: { key: 'REUSABLE_PAGES', value: 'Reusable Pages' },
    REUSABLE_PAGES_DESC: {
        key: 'REUSABLE_PAGES_DESC',
        value: 'Design, edit, and manage your reusable pages',
    },
    REUSABLE_SECTIONS: { key: 'REUSABLE_SECTIONS', value: 'Reusable Sections' },
    REUSABLE_SECTIONS_DESC: {
        key: 'REUSABLE_SECTIONS_DESC',
        value: 'Design, edit, and manage your reusable sections',
    },

    // DocumentGrid
    SORT: { key: 'SORT', value: 'Sort' },
    DATE_MODIFIED: { key: 'DATE_MODIFIED', value: 'Date Modified' },
    NAME_AZ: { key: 'NAME_AZ', value: 'Name (A-Z)' },
    NO_DOCUMENTS_FOUND: {
        key: 'NO_DOCUMENTS_FOUND',
        value: 'No documents found',
    },
    NO_REUSABLE_PAGES_FOUND: {
        key: 'NO_REUSABLE_PAGES_FOUND',
        value: 'No reusable pages found',
    },
    NO_REUSABLE_SECTIONS_FOUND: {
        key: 'NO_REUSABLE_SECTIONS_FOUND',
        value: 'No reusable sections found',
    },
    TRY_ADJUSTING_FILTERS: {
        key: 'TRY_ADJUSTING_FILTERS',
        value: 'Try adjusting your filters or search query',
    },
    LOADING: { key: 'LOADING', value: 'Loading ...' },
    NO_MORE_DATA: { key: 'NO_MORE_DATA', value: 'No more data to load' },
    FETCH_DOCUMENTS_ERROR: {
        key: 'FETCH_DOCUMENTS_ERROR',
        value: 'Something went wrong while fetching documents',
    },
    FETCH_PAGES_ERROR: {
        key: 'FETCH_PAGES_ERROR',
        value: 'Failed to fetch reusable pages. Please try again later!',
    },
    FETCH_BLOCKS_ERROR: {
        key: 'FETCH_BLOCKS_ERROR',
        value: 'Failed to fetch reusable blocks. Please try again!',
    },
    COMMUNICATIONS: { key: 'COMMUNICATIONS', value: 'Communications' },
    ALL_DOCUMENTS: { key: 'ALL_DOCUMENTS', value: 'All Documents' },
    ALL_REUSABLE_PAGES: {
        key: 'ALL_REUSABLE_PAGES',
        value: 'All Reusable Pages',
    },
    ALL_REUSABLE_SECTIONS: {
        key: 'ALL_REUSABLE_SECTIONS',
        value: 'All Reusable Sections',
    },

    // CreateResource
    CREATE_CATEGORY: { key: 'CREATE_CATEGORY', value: 'Create Category' },
    CATEGORY_NAME_REQUIRED: {
        key: 'CATEGORY_NAME_REQUIRED',
        value: 'Category name is required',
    },
    ENTER_CATEGORY_NAME: {
        key: 'ENTER_CATEGORY_NAME',
        value: 'Enter category name',
    },
    CREATE_TEAM: { key: 'CREATE_TEAM', value: 'Create Team' },
    TEAM_NAME_REQUIRED: {
        key: 'TEAM_NAME_REQUIRED',
        value: 'Team name is required',
    },
    ENTER_TEAM_NAME: { key: 'ENTER_TEAM_NAME', value: 'Enter team name' },
    CREATE_FOLDER: { key: 'CREATE_FOLDER', value: 'Create Folder' },
    FOLDER_NAME_REQUIRED: {
        key: 'FOLDER_NAME_REQUIRED',
        value: 'Folder name is required',
    },
    ENTER_FOLDER_NAME: {
        key: 'ENTER_FOLDER_NAME',
        value: 'Enter folder name',
    },
    TEAM_REQUIRED: { key: 'TEAM_REQUIRED', value: 'Team is required' },
    SELECT_TEAM: { key: 'SELECT_TEAM', value: 'Select team' },
    CREATE: { key: 'CREATE', value: 'Create' },
    CATEGORY_CREATED: { key: 'CATEGORY_CREATED', value: 'Category created' },
    CATEGORY_CREATION_FAILED: {
        key: 'CATEGORY_CREATION_FAILED',
        value: 'Failed to create category. Please try again!',
    },
    FOLDER_CREATED: { key: 'FOLDER_CREATED', value: 'Folder created' },
    FOLDER_CREATION_FAILED: {
        key: 'FOLDER_CREATION_FAILED',
        value: 'Failed to create folder. Please try again!',
    },
    TEAM_CREATED: { key: 'TEAM_CREATED', value: 'Team created' },
    TEAM_CREATION_FAILED: {
        key: 'TEAM_CREATION_FAILED',
        value: 'Failed to create team. Please try again!',
    },
    LOAD_TEAMS_FAILED: {
        key: 'LOAD_TEAMS_FAILED',
        value: 'Failed to load teams',
    },

    // DocumentCard
    LANGUAGES_COUNT: { key: 'LANGUAGES_COUNT', value: 'languages' },
    EDIT: { key: 'EDIT', value: 'Edit' },
    DELETE: { key: 'DELETE', value: 'Delete' },
    TEMPLATE_DELETED: {
        key: 'TEMPLATE_DELETED',
        value: 'The template has been deleted.',
    },

    // TagSearch
    PLACEHOLDER_SEARCH_BY_TAGS: {
        key: 'PLACEHOLDER_SEARCH_BY_TAGS',
        value: 'Search by tags',
    },
    LANGUAGES_AVAILABLE: {
        key: 'LANGUAGES_AVAILABLE',
        value: 'Languages Available',
    },
    VIEW_ALL_LANGUAGES_TOOLTIP: {
        key: 'VIEW_ALL_LANGUAGES_TOOLTIP',
        value: 'View all languages',
    },
};
